import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBitbucketDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 54 54",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.71431 2.88428C0.905904 2.88428 -0.283122 4.33352 0.0585268 6.12127L8.10044 48.2023C8.44209 49.9899 10.185 51.4393 11.9935 51.4393H42.0064C43.8148 51.4393 45.5578 49.9899 45.8996 48.2023L53.9415 6.12127C54.283 4.33352 53.0941 2.88428 51.2857 2.88428H2.71431ZM32.0588 34.9575L35.0385 19.3661H18.9616L21.9413 34.9575H32.0588Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgBitbucketDark);
export { ForwardRef as ReactComponent };
